export const resolveLessonModuleId = async (
  { moduleId = null, courseId, deliveryMode },
  operations,
) => {
  if (moduleId) return moduleId;
  if (!courseId) return null;

  const modules = await operations.findModules(courseId, deliveryMode);
  if (modules.length > 0) return modules[0].id;

  const created = await operations.createModule({
    course_id: courseId,
    title: "Course Content",
    description: "Main course content module",
    sort_order: 1,
    is_published: true,
    delivery_mode: deliveryMode,
  });
  if (!created?.id) throw new Error("Default course module was not created");
  return created.id;
};
